// src/services/productService.js
import api from './api';

const productService = {
  /**
   * Get all products
   * @returns {Promise<Array>} List of products
   */
  getAllProducts: async () => {
    const response = await api.get('/products');
    return response.data;
  },

  /**
   * Get product by ID
   * @param {number} productId - Product ID
   * @returns {Promise<Object>} Product details
   */
  getProductById: async (productId) => {
    const response = await api.get(`/products/${productId}`);
    return response.data;
  },

  /**
   * Get products by college (MAIN FILTERING FEATURE)
   * @param {number} collegeId - College ID
   * @returns {Promise<Array>} Filtered products
   */
  getProductsByCollege: async (collegeId) => {
    const response = await api.get(`/products/college/${collegeId}`);
    return response.data;
  },

  /**
   * Get products by category
   * @param {string} category - T_SHIRT or HOODIE
   * @returns {Promise<Array>} Filtered products
   */
  getProductsByCategory: async (category) => {
    const response = await api.get(`/products/category/${category}`);
    return response.data;
  },

  /**
   * Get products by college and category
   * @param {number} collegeId - College ID
   * @param {string} category - T_SHIRT or HOODIE
   * @returns {Promise<Array>} Filtered products
   */
  getProductsByCollegeAndCategory: async (collegeId, category) => {
    const response = await api.get(`/products/college/${collegeId}/category/${category}`);
    return response.data;
  },

  /**
   * Get featured products
   * @returns {Promise<Array>} Featured products for homepage
   */
  getFeaturedProducts: async () => {
    const response = await api.get('/products/featured');
    return response.data;
  },

  /**
   * Search products
   * @param {string} query - Search query
   * @returns {Promise<Array>} Search results
   */
  searchProducts: async (query) => {
    const response = await api.get('/products/search', {
      params: { q: query },
    });
    return response.data;
  },
};

export default productService;